import { Box } from '@mui/material';
import { CcfTypography } from '../core/ccf-typography/ccf-typography';


import styles from './ccf-action-editor-content-title.module.scss';

export interface CcfActionEditorContentTitleProps {
  title: string;
  step: number;
}

/**
 * Component for the Action Editor content title
 * @param props - CcfActionEditorContentTitleProps
 * @returns component for Action Editor content title
 * @example <CcfActionEditorContentTitle/>
 */
export function CcfActionEditorContentTitle(props: CcfActionEditorContentTitleProps) {
  return (
    <Box className={styles.container}>
      <Box className={styles.stepContainer}>
        <CcfTypography className={styles.step}>{props.step}</CcfTypography>
      </Box>

      <CcfTypography className={styles.title}>{props.title}</CcfTypography>
    </Box>
  );
}

export default CcfActionEditorContentTitle;
